import { useState } from "react";
import { useNavigate } from "react-router-dom";

import Loading from "../../../components/Loading";
import Data from '../../../../repository';
import styles from '../../../../styles/Admin.module.scss';

function CreateWalletPackageForm() {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [serverError, setServerError] = useState(null);
	const [form, setForm] = useState({
		name: '',
		description: '',
		purchaseAmount: '',
		creditAmount: '',
		enabled: true,
		sortOrder: 0
	});

	const onSubmit = async (event) => {
		event.preventDefault();
		setLoading(true);
		setServerError(null);

		try {
			await Data.createWalletPackage({
				...form,
				purchaseAmount: Number(form.purchaseAmount),
				creditAmount: Number(form.creditAmount),
				sortOrder: Number(form.sortOrder || 0),
				enabled: !!form.enabled
			});
			navigate("/admin/wallet-packages");
		} catch (error) {
			setServerError(error.response?.data?.message || 'Failed to create wallet package.');
			setLoading(false);
		}
	};

	return (
		<form onSubmit={onSubmit} className={styles.form}>
			<div>
				<p>Name: *</p>
				<input type="text" value={form.name} onChange={(event) => setForm({ ...form, name: event.target.value })} required />
			</div>

			<div>
				<p>Description:</p>
				<input type="text" value={form.description} onChange={(event) => setForm({ ...form, description: event.target.value })} />
			</div>

			<div>
				<p>Customer Pays - in pence: *</p>
				<input type="number" value={form.purchaseAmount} onChange={(event) => setForm({ ...form, purchaseAmount: event.target.value })} required />
			</div>

			<div>
				<p>Wallet Credit - in pence: *</p>
				<input type="number" value={form.creditAmount} onChange={(event) => setForm({ ...form, creditAmount: event.target.value })} required />
			</div>

			<div>
				<p>Sort Order:</p>
				<input type="number" value={form.sortOrder} onChange={(event) => setForm({ ...form, sortOrder: event.target.value })} />
			</div>

			<div>
				<p>Status:</p>
				<select value={form.enabled ? 'true' : 'false'} onChange={(event) => setForm({ ...form, enabled: event.target.value === 'true' })}>
					<option value="true">Enabled</option>
					<option value="false">Disabled</option>
				</select>
			</div>

			{serverError ? <p style={{ color: 'red' }}>{serverError}</p> : null}

			<button type="submit" className="btn btnPrimary" disabled={loading}>
				{loading ? <Loading button={true} /> : 'Create Wallet Package'}
			</button>
		</form>
	);
}

export default CreateWalletPackageForm;
